import React from "react";

const projectImages = [
  // {
  //   src: "images/RAHEJA/1.jpg",
  //   url: "https://www.raheja-district.navi-mumbai-project.com/",
  // },
  // {
  //   src: "images/RAHEJA/2.jpg",
  //   url: "https://raheja-primeone-juinagar.navi-mumbai-project.com/",
  // },
  
];

const Raheja = () => {
  return (
    <div className="container mx-auto px-1 sm:px-8" id="gallery">
      <h1 className="text-4xl sm:text-4xl md:text-5xl lg:text-[48px] font-bold text-center my-8 transition-all duration-300">
        RAHEJA PROJECTS
      </h1>
      <div className="flex flex-wrap gap-[1vh] p-[1vh] max-w-full mx-auto bg-[#126958] justify-center">
        {projectImages.map((image, index) => (
          <div
            key={index}
            className="w-full sm:w-[calc(50%-1vh)] md:w-[calc(33.333%-1vh)] gallery-item group"
          >
            <a href={image.url} target="_blank" rel="noopener noreferrer">
              <img
                src={image.src}
                alt={`Gallery ${index + 1}`}
                className="w-full h-[300px] object-cover transition-all duration-100 ease-out group-hover:scale-104 group-hover:filter-none"
              />
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Raheja;
